import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { distinctUntilChanged } from 'rxjs/operators';
import { config } from 'src/app/configs/config';
import { Store } from 'src/app/core/store/store';
import { Course } from 'src/app/shared/models/course.model';
import { User } from 'src/app/shared/models/user.model';
import { UtilityService } from 'src/app/shared/utils/utility.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  activesection: string = 'content';
  @Input() courseId: string;
  @Input() isNotes: boolean = false;
  @Input() moduleOverview;
  activeNotes: boolean = false;
  activeResources: boolean = false;
  @Output() openModuleOverview = new EventEmitter<any>();
  @Output() hideWalkthrough = new EventEmitter<any>();
  @Output() hideCourseProgress = new EventEmitter<any>();
  @Output() hideSidebar = new EventEmitter<boolean>();
  activeContent: boolean = false;
  activeQanda: boolean = false;
  subscription: Subscription;
  modules = [];
  resourceExists = false;
  isLocked: boolean = false;
  totalMessageLength;
  course:Course
  dataCourseLoader: any = true
  constructor(private store: Store, private utilityService: UtilityService) {

    this.store.select('courseLoader').pipe(distinctUntilChanged()).subscribe(res => {
      this.dataCourseLoader = res
    })
  }
  @Output() clicked: EventEmitter<boolean> = new EventEmitter();
  ngOnInit() {
    this.utilityService.tabSelection$.subscribe(currentTab => {
      this.activesection = currentTab;
      this.activeNotes = true;
      this.hideSidebar.emit(true);
    })
    this.isNotes && (this.activesection = 'notes');
    this.subscription = this.store.select<Course>(`course`).subscribe(course => {
      if (course) {
        this.course = course;
        this.modules = [];
        for (let cont of course.contents) {
          let i = this.modules.findIndex(g => g.moduleNumber == cont.moduleNumber);
          (i >= 0 && this.modules[i].contents.push(cont.contentInfo)) || this.modules.push({ moduleName: cont.moduleName, moduleNumber: cont.moduleNumber, contents: [cont.contentInfo] })
        }
        this.modules = this.modules.sort((a, b) => a.moduleNumber - b.moduleNumber);
        this.checkIfResourceExists();
        this.subscription && this.subscription.unsubscribe()
        this.subscription = null;
      }
    });

    this.store.select<User>('user').subscribe(user => {
      if (user && config.B2C_ORGANIZATIONS.includes(user.organization)) {
        if (user.cohorts && user.cohorts.length) {
          let i = user.cohorts.findIndex(el => el.trait == this.course.trait);
          this.isLocked = i == -1;
        } else {
          this.isLocked = true;
        }
      }
    })
  }

  checkIfResourceExists() {
    this.modules.forEach((mod) => {
      if (this.isResourcesExists(mod)) {
        this.resourceExists = true;
        return;
      }
    });
  }


  isResourcesExists(module) {
    if (module.contents.length)
      return module.contents.some(el => el.cards && el.cards.length > 0);
    return false;
  }

  emitEvent() {
    this.clicked.emit(true);
  }

  getMessageLength(event){
    this.totalMessageLength = event;
  }

  showModuleOverview(mod){
    this.openModuleOverview.emit(mod);
  }
  
  _hideWalkthrough(){
    this.hideWalkthrough.emit();
  }

  _hideCourseProgress(){
    this.hideCourseProgress.emit();
  }


}
